import React, { useState, useEffect, useContext } from 'react';
import './list.scss';
import NewList from '@/components/List/newList';
import Detail from '@/components/List/detail';
import { useHistory } from 'react-router-dom';
import { Context } from '@/models/home';
// import http from '@/server';
// import { Tooltip } from 'antd';

import { RightOutlined } from '@ant-design/icons';

function List() {
  let history = useHistory();
  const HomeContext = useContext(Context);
  history.listen((route) => {
    if (decodeURI(getQueryVariable('keywords')) !== 'false') {
      document.title =
        '江苏省通信学会 - ' + decodeURI(getQueryVariable('keywords'));
    } else if (decodeURI(getQueryVariable('title')) !== 'false') {
      document.title =
        '江苏省通信学会 - ' +
        HomeContext.state.menuTypeList[
          decodeURI(getQueryVariable('title')).split('/')[0]
        ];
    } else {
      document.title = '江苏省通信学会';
    }

    // console.log(route); // 这个route里面有当前路由的各个参数信息
    if (getQueryVariable('id') && id !== getQueryVariable('id')) {
      setID(getQueryVariable('id'));
      setTitleArr(decodeURI(getQueryVariable('title')).split('/'));
    }
    if (
      decodeURI(getQueryVariable('title')).split('/') &&
      titleArr !== decodeURI(getQueryVariable('title')).split('/')
    ) {
      setTitleArr(decodeURI(getQueryVariable('title')).split('/'));
    }
  });

  const [path, setPath] = useState(
    history.location.pathname.substr(1, history.location.pathname.length),
  );

  const [titleArr, setTitleArr] = useState();
  const [menuList, setMenuList] = useState();
  const [id, setID] = useState();
  // const [newsListzx, setNewsListzx] = useState();

  useEffect(() => {
    if (decodeURI(getQueryVariable('keywords')) !== 'false') {
      document.title =
        '江苏省通信学会 - ' + decodeURI(getQueryVariable('keywords'));
    } else if (decodeURI(getQueryVariable('title')) !== 'false') {
      document.title =
        '江苏省通信学会 - ' +
        HomeContext.state.menuTypeList[
          decodeURI(getQueryVariable('title')).split('/')[0]
        ];
    } else {
      document.title = '江苏省通信学会';
    }
    // getNewsLIst();
    if (
      HomeContext.state.menuList &&
      Object.keys(HomeContext.state.menuList).length > 0
    ) {
      setMenuList(HomeContext.state.menuList);
    } else {
      setMenuList(JSON.parse(window.localStorage.getItem('menuList')));
    }
    setTitleArr(decodeURI(getQueryVariable('title')).split('/'));
  }, [id]);

  // 获取最新咨询
  // const getNewsLIst = () => {
  //   // const menus =
  //   //   HomeContext.state.menuList &&
  //   //   Object.keys(HomeContext.state.menuList).length > 0
  //   //     ? HomeContext.state.menuList
  //   //     : JSON.parse(window.localStorage.getItem('menuList'));
  //   // const titleArr = decodeURI(getQueryVariable('title')).split('/');
  //   // let pid = '';
  //   // menus &&
  //   //   titleArr &&
  //   //   titleArr.length > 0 &&
  //   //   menus[titleArr[0]] &&
  //   //   menus[titleArr[0]].length > 0 &&
  //   //   menus[titleArr[0]].map((item) => {
  //   //     pid = item.title == titleArr[titleArr.length - 1] ? item.pid : pid;
  //   //   });
  //   let params = {
  //     page: 1,
  //     pageSize: 10,
  //     cid: '',
  //   };
  //   http.get('/news/achieve_list', params).then((res) => {
  //     // console.log(res.data.data);
  //     setNewsListzx(res.data.data);
  //   });
  // };

  // const toNewsList = () => {
  //   history.push(`list?title=最新资讯&id=${newsListzx[0].cid}`);
  // };

  // 截取url参数
  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  };

  const toRouter = (path, item) => {
    if (item.link_url) return window.open(item.link_url);
    history.push(`${path} `);
  };

  const toQuick = (title) => {
    if (HomeContext.state.menuList) {
      for (let j = 0; j < Object.keys(HomeContext.state.menuList).length; j++) {
        const i = Object.keys(HomeContext.state.menuList)[j];
        for (
          let index = 0;
          index < HomeContext.state.menuList[i].length;
          index++
        ) {
          const item = HomeContext.state.menuList[i][index];
          if (item.title === title) {
            history.push(item.path);
          }
        }
      }
    }
    // HomeContext.state.menuList &&
    //   Object.keys(HomeContext.state.menuList).map((i) => {
    //     HomeContext.state.menuList[i].map((item) => {
    //       if (item.title === title) {
    //         history.push(item.path);
    //       }
    //     });
    //   });
  };

  const toMenu = (title) => {
    if (HomeContext.state.menuList) {
      for (let j = 0; j < Object.keys(HomeContext.state.menuList).length; j++) {
        const i = Object.keys(HomeContext.state.menuList)[j];
        for (
          let index = 0;
          index < HomeContext.state.menuList[i].length;
          index++
        ) {
          const item = HomeContext.state.menuList[i][index];
          if (item.title === title) {
            history.push(item.path);
          }
        }
      }
    }
    if (HomeContext.state.newsTypeList) {
      for (
        let index = 0;
        index < HomeContext.state.newsTypeList.length;
        index++
      ) {
        const i = HomeContext.state.newsTypeList[index];
        if (i.name === title) {
          history.push(`/list?title=${title}&id=${i.id}&isMenu=true`);
        }
      }
    }
  };

  return (
    <div className="listBox center clearfix">
      <div className="leftMenu">
        {decodeURI(getQueryVariable('title')) != 'ssjg' &&
        decodeURI(getQueryVariable('title')) != '网站公告' ? (
          <>
            <div className="title-menu">
              {titleArr && HomeContext.state.menuTypeList[titleArr[0]]}
            </div>
            <ul className="t-menu">
              {menuList &&
                titleArr &&
                menuList[titleArr[0]] &&
                menuList[titleArr[0]].length > 0 &&
                menuList[titleArr[0]].map((item, index) => {
                  if (item.title == titleArr[titleArr.length - 1].trim()) {
                    return (
                      item.title && (
                        <li
                          onClick={toRouter.bind(this, item.path, item)}
                          className="liAct"
                          key={index}
                        >
                          <span>
                            {HomeContext.state.menuTypeList[item.title]}
                          </span>
                          <RightOutlined />
                        </li>
                      )
                    );
                  } else {
                    return (
                      item.title && (
                        <li
                          onClick={toRouter.bind(this, item.path, item)}
                          key={item.path}
                        >
                          <span>
                            {HomeContext.state.menuTypeList[item.title]}
                          </span>
                          <RightOutlined />
                        </li>
                      )
                    );
                  }
                })}
            </ul>
          </>
        ) : null}
        {/* <div className="titles">
          <h2>最新资讯</h2>
          <span onClick={toNewsList}>更多 +</span>
        </div>
        <ul className="b-menu">
          {newsListzx &&
            newsListzx.length > 0 &&
            newsListzx.map((item) => {
              return (
                <Tooltip placement="top" title={item.title}>
                  <li
                    onClick={toRouter.bind(
                      this,
                      `detail?title=最新资讯&id=${item.id}`,
                      item,
                    )}
                  >
                    <div></div>
                    <span>{item.title}</span>
                  </li>
                </Tooltip>
              );
            })}
        </ul> */}
        <div className="title clearfix">
          <div>快捷导航</div>
        </div>
        <ul className="kjdh">
          {/* <li onClick={toQuick.bind(this, '世界电信和社会信息日纪念大会')}>
            <span>世界电信和社会信息日纪念大会</span>
            <RightOutlined />
          </li>
          <li onClick={toQuick.bind(this, '江苏省信息通信行业科学技术奖')}>
            <span>
              江苏省信息通信行业科学技术奖
              <br />
              科学技术奖
            </span>
            <RightOutlined />
          </li>
          <li onClick={toQuick.bind(this, '青年学术论坛')}>
            <span>青年学术论坛</span>
            <RightOutlined />
          </li>
          <li onClick={toQuick.bind(this, '论文征集')}>
            <span>论文征集</span>
            <RightOutlined />
          </li>
          <li onClick={toQuick.bind(this, '加入学会')}>
            <span>加入学会</span>
            <RightOutlined />
          </li> */}
          <li onClick={toQuick.bind(this, 'sjdxhxxshrjndh')}>
            {/* <span>世界电信和社会信息日纪念大会</span>
              <RightOutlined /> */}
            <img src={require('@/assets/home/main3(1).png').default} alt="" />
          </li>
          <li onClick={toQuick.bind(this, 'jsxxtxhykxjsj')}>
            <img src={require('@/assets/home/main3(2).png').default} alt="" />
          </li>
          <li onClick={toQuick.bind(this, 'qnxslt')}>
            <img src={require('@/assets/home/main3(3).png').default} alt="" />
          </li>
          <li onClick={toQuick.bind(this, 'lwzj')}>
            <img src={require('@/assets/home/main3(4).png').default} alt="" />
          </li>
          <li onClick={toQuick.bind(this, 'jrxh')}>
            <img src={require('@/assets/home/main3(5).png').default} alt="" />
          </li>
        </ul>
      </div>

      <div className="rightBox">
        <div className="title">
          <b>
            {titleArr && titleArr[0] !== 'ssjg'
              ? HomeContext.state.menuTypeList[titleArr[titleArr.length - 1]]
              : '搜索结果'}
          </b>
          <span>
            <img src={require('@/assets/home/home.png').default} alt="" />
            <i
              onClick={() => {
                history.push('/');
              }}
            >
              首页
            </i>{' '}
            {titleArr &&
              titleArr.map((item, index) => {
                return (
                  <i onClick={toMenu.bind(this, item)} key={index}>
                    &gt; {HomeContext.state.menuTypeList[item]}
                  </i>
                );
              })}
          </span>
        </div>

        {path === 'list' ? <NewList /> : <Detail />}
      </div>
    </div>
  );
}

export default List;
